import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { setValueByKey } from '../../../../../utils/utils'
import { getLanguageValue } from '../../../../../utils/getLanguageValue'
import InformationPopover from '../../../../InformationPopover/InformationPopover'
import { Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import LanguageNameInput from '../../../../Forms/LanguageNameInput'
import OverlayContainer from '../../../../Page/logix2020/OverlayContainer'
import OverlayRight from '../../../../Page/logix2020/OverlayRight'
import LanguageForm from '../../../../Forms/LanguageForm'
import { colors } from '../../../../../styles/colors'
import { useArticleDataState } from '../../../../../stores/Configuration/ArticleDataProvider'
import { StyledValidationMessage } from '../../formHelper'
import ModalComponent from '../../../../Modals/ModalComponent'
import trash from '../../../../../assets/icons/trash.svg'
import { Link } from 'react-router-dom'

const StyledRemoveLink = styled(Link)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #ffe5e5;
  color: #ff0000;
  border: 1px solid #ffb3b3;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 0.9rem;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s ease, color 0.2s ease;
  margin-top: 10px;

  &:hover {
    background-color: #ffd6d6;
    color: #bf0000;
  }

  &:after {
    content: '';
    width: 1em;
    height: 1.1em;
    display: inline-block;
    margin-left: 0.4em;
    position: relative;
    top: -1px;
    background: url(${trash}) center center no-repeat;
    background-size: contain;
  }

  @media (max-width: 991px) {
    font-size: 0.85rem;
    padding: 6px 10px;
  }

  @media (max-width: 567px) {
    width: 100%;
    justify-content: center;
    padding: 8px;
  }
`

const StyledSizeCard = styled.div`
  ${(props) =>
    props.autoScrollHere
      ? `border:3px dashed ${props.theme.primaryColor}`
      : ''};
  padding: 0 45px 0 20px;
  border-bottom: 1px solid ${colors.gray3};
`
const SizeCard = ({ size, sizeSystemId, sizeSystemIndex, sizeIndex }) => {
  const {
    actionMode,
    sizeSystems,
    getFormErrorByKey,
    resetFormErrorByKey,
    changeSizeByKey,
    removeSize,
  } = useArticleDataState()
  const { t } = useTranslation()
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [overlayNameIsVisible, setOverlayNameIsVisible] = useState(false)
  //const [overlayDimension1IsVisible, setOverlayDimension1IsVisible] = useState(false)
  //const [overlayDimension2IsVisible, setOverlayDimension2IsVisible] = useState(false)
  const [sizeObj, setSizeObj] = useState(size)
  const updateTranslations = (name) => (translations) => {
    setSizeObj((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        values: translations,
      },
    }))
    resetFormError(name)
  }
  const updateInputFields = (e) => {
    const { target } = e
    let key = target.name
    let value = null
    switch (key) {
      case 'price':
        setSizeObj((prev) => ({
          ...prev,
          price: {
            ...prev.price,
            value: parseFloat(target.value) || null,
          },
        }))
        break
      default:
        if (target.type === 'checkbox') {
          value = target.checked
        } else {
          value = target.value
        }
        setSizeObj((prev) => setValueByKey(key, value, prev))
        break
    }
    resetFormError(key)
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    changeSizeByKey(sizeSystemId, size.id, sizeObj)
  }, [sizeSystemId, size.id, sizeObj])
  /* eslint-enable react-hooks/exhaustive-deps */

  const getSizeSystemIndex = () => {
    let index = sizeSystemIndex
    if (actionMode === 'copy') {
      let selectedSystems = sizeSystems.filter((item) => item.isSelected)
      index = selectedSystems.findIndex((item) => item.id === sizeSystemId)
    }
    return index
  }
  const getFormError = (name) => {
    let index = getSizeSystemIndex()
    let key = `${index}sizes${sizeIndex}${name}`
    return getFormErrorByKey('saveSizeSystems', key)
  }
  const resetFormError = (name) => {
    let index = getSizeSystemIndex()
    let key = `${index}sizes${sizeIndex}${name}`
    resetFormErrorByKey('saveSizeSystems', key)
  }
  const handleOpenLanguageModal = (setData) => {
    handleCloseOverlay()
    setData(true)
  }
  const handleCloseOverlay = () => {
    setOverlayNameIsVisible(false)
    //setOverlayDimension1IsVisible(false)
    //setOverlayDimension2IsVisible(false)
  }
  const handleDeleteSizeModal = async () => {
    removeSize(sizeSystemId, size.id)
  }
  const getSizeName = () => {
    let sizeName = getLanguageValue(sizeObj.name.values)
    return sizeName ? `(${sizeName})` : ''
  }
  const foreignKeyIsEnabled = () => {
    return actionMode === 'copy' || size.isNewPosition || !sizeObj.foreignKey
  }
  return (
    <StyledSizeCard data-id={`${sizeSystemId}_${size.id}`}>
      <div className='d-flex justify-content-end p-2'>
        <StyledRemoveLink
          to={'#'}
          onClick={(e) => {
            e.preventDefault()
            setOpenDeleteModal(true)
          }}
          tabIndex={-1}
        >
          {t('deleteButton')}
        </StyledRemoveLink>
      </div>
      <Row className='mb-3'>
        <Col xs={12} sm={6} md={6}>
          <LanguageNameInput
            openLanguageModal={() =>
              handleOpenLanguageModal(setOverlayNameIsVisible)
            }
            languageArray={sizeObj.name.values}
            onChange={updateTranslations('name')}
            label={t('sizeAdmin:name')}
            isInvalid={!!getFormError('name')}
          />
          {!!getFormError('name') && (
            <StyledValidationMessage>
              {getFormError('name')}
            </StyledValidationMessage>
          )}
        </Col>
        <Col xs={12} sm={6} md={6}>
          <Form.Group>
            <Form.Label>
              {t('costCenterAdmin:foreignKey')}
              {foreignKeyIsEnabled() && (
                <InformationPopover
                  header={t('costCenterAdmin:foreignKey')}
                  content={t('officeAdmin:noteForeignKey')}
                />
              )}
            </Form.Label>
            <Form.Control
              id={`${sizeSystemIndex}sizes${sizeIndex}foreignKey`}
              name='foreignKey'
              placeholder={t('costCenterAdmin:foreignKey')}
              value={sizeObj.foreignKey}
              disabled={!foreignKeyIsEnabled()}
              onChange={updateInputFields}
              isInvalid={!!getFormError('foreignKey')}
            />
            <Form.Control.Feedback type='invalid'>
              {getFormError('foreignKey')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      {/*<Row className="mb-3">
                <Col>
                    <LanguageNameInput
                        openLanguageModal={() => handleOpenLanguageModal(setOverlayDimension1IsVisible)}
                        languageArray={sizeObj.dimension1.values}
                        onChange={updateTranslations("dimension1")}
                        label={t('sizeAdmin:dimension1')}
                        isInvalid={!!getFormError("dimension1")}
                    />
                    {(!!getFormError("dimension1")) &&
                        <StyledValidationMessage>{getFormError("dimension1")}</StyledValidationMessage>
                    }
                </Col>
                <Col>
                    <LanguageNameInput
                        openLanguageModal={() => handleOpenLanguageModal(setOverlayDimension2IsVisible)}
                        languageArray={sizeObj.dimension2.values}
                        onChange={updateTranslations("dimension2")}
                        label={t('sizeAdmin:dimension2')}
                        isInvalid={!!getFormError("dimension2")}
                    />
                    {(!!getFormError("dimension2")) &&
                        <StyledValidationMessage>{getFormError("dimension2")}</StyledValidationMessage>
                    }
                </Col>
            </Row>*/}
      <Row className='mb-3'>
        <Col xs={12} sm={6} md={6}>
          <Form.Group>
            <Form.Label>{t('sizeAdmin:supplierAlias')}</Form.Label>
            <Form.Control
              id={`${sizeSystemIndex}sizes${sizeIndex}supplierAlias`}
              name='supplierAlias'
              placeholder={t('sizeAdmin:supplierAlias')}
              value={sizeObj.supplierAlias ?? ''}
              onChange={updateInputFields}
              isInvalid={!!getFormError('supplierAlias')}
            />
            <Form.Control.Feedback type='invalid'>
              {getFormError('supplierAlias')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>{`${t('sizeAdmin:pricePerItem')} (${
              sizeObj.price?.currency?.isoCode ?? ''
            })`}</Form.Label>
            <Form.Control
              id={`${sizeSystemIndex}sizes${sizeIndex}price`}
              value={sizeObj.price?.value ?? ''}
              name='price'
              type='number'
              min='0'
              onWheel={(e) => e.target.blur()}
              onChange={updateInputFields}
              isInvalid={!!getFormError('price')}
            />
            <Form.Control.Feedback type='invalid'>
              {getFormError('price')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      {/*<Row className='mb-3'>
        <Col xs={12} sm={6} md={6}>
          <Form.Group>
            <Form.Label>{`${t('sizeAdmin:pricePerItem')} (${sizeObj.price?.currency?.isoCode ?? ''
              })`}</Form.Label>
            <Form.Control
              id={`${sizeSystemIndex}sizes${sizeIndex}price`}
              value={sizeObj.price?.value ?? ''}
              name='price'
              type='number'
              min='0'
              onWheel={(e) => e.target.blur()}
              onChange={updateInputFields}
              isInvalid={!!getFormError('price')}
            />
            <Form.Control.Feedback type='invalid'>
              {getFormError('price')}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col></Col>
      </Row>*/}
      <Row className='mb-3'>
        <Col>
          <Form.Check
            type='checkbox'
            id={`${sizeSystemIndex}sizes${sizeIndex}isObsolet`}
            name='isObsolet'
            label={t('sizeAdmin:isObsolet')}
            checked={sizeObj.isObsolet}
            onChange={updateInputFields}
            isInvalid={!!getFormError('isObsolet')}
          />
          <Form.Control.Feedback type='invalid'>
            {getFormError('isObsolet')}
          </Form.Control.Feedback>
        </Col>
        <Col>
          <Form.Check
            type='checkbox'
            id={`${sizeSystemIndex}sizes${sizeIndex}isLocked`}
            name='isLocked'
            label={t('sizeAdmin:isLocked')}
            checked={sizeObj.isLocked}
            onChange={updateInputFields}
            isInvalid={!!getFormError('isLocked')}
          />
          <Form.Control.Feedback type='invalid'>
            {getFormError('isLocked')}
          </Form.Control.Feedback>
        </Col>
      </Row>
      <OverlayContainer>
        {overlayNameIsVisible && (
          <OverlayRight
            visible={overlayNameIsVisible}
            onClose={handleCloseOverlay}
          >
            <LanguageForm
              languageTitle={t('sizeAdmin:name')}
              handleCloseOverlay={handleCloseOverlay}
              languageArray={sizeObj.name.values}
              onChange={updateTranslations('name')}
            />
          </OverlayRight>
        )}
        {/*}
                {overlayDimension1IsVisible && <OverlayRight visible={overlayDimension1IsVisible} onClose={handleCloseOverlay}>
                    <LanguageForm
                        languageTitle={`${t('sizeAdmin:dimension1')} ${getSizeName()}`}
                        handleCloseOverlay={handleCloseOverlay}
                        languageArray={sizeObj.dimension1.values}
                        onChange={updateTranslations("dimension1")}
                    />
                </OverlayRight>}
                {overlayDimension2IsVisible && <OverlayRight visible={overlayDimension2IsVisible} onClose={handleCloseOverlay}>
                    <LanguageForm
                        languageTitle={`${t('sizeAdmin:dimension2')} ${getSizeName()}`}
                        handleCloseOverlay={handleCloseOverlay}
                        languageArray={sizeObj.dimension2.values}
                        onChange={updateTranslations("dimension2")}
                    />
                </OverlayRight>}
                */}
      </OverlayContainer>
      {openDeleteModal && (
        <ModalComponent
          ModalTitle={`${t('sizeAdmin:size')} ${getSizeName()}`}
          functionButton1={() => handleDeleteSizeModal(openDeleteModal)}
          textButton1={t('delete')}
          variantButton1='danger'
          variantBody='alert-danger'
          BodyPart1={t('sizeAdmin:askRemoveSize')}
          functionCancel={() => {
            setOpenDeleteModal(false)
          }}
        />
      )}
    </StyledSizeCard>
  )
}

export default SizeCard
